import { Component, Input, Output, EventEmitter } from '@angular/core'
import { HttpService, ViewService } from '../shared'

@Component({
	selector: 'navigator',
	template: require('./navigator.component.html'),
	styles: [require('./navigator.component.scss'), require('../app.component.scss')]
})

export class NavigatorComponent {
	@Output() onGoEvent = new EventEmitter();
	@Output() proxyChanged = new EventEmitter();
	prorocol_pattern = new RegExp('https?:\/\/');
	constructor(private httpService: HttpService, private viewService: ViewService) {
	}

	onGo() {
		if (!this.prorocol_pattern.exec(this.httpService.current_url)) {
			this.httpService.current_url = 'http://' + this.httpService.current_url;
		}
		this.onGoEvent.emit({url: this.httpService.current_url});
	}

	onProxyChanged() {
		this.proxyChanged.emit({proxy: this.httpService.proxy})
	}
}
